import { render, staticRenderFns } from "./Etaziranje.vue?vue&type=template&id=312d24a2&scoped=true&"
import script from "./Etaziranje.vue?vue&type=script&lang=js&"
export * from "./Etaziranje.vue?vue&type=script&lang=js&"
import style0 from "./Etaziranje.vue?vue&type=style&index=0&id=312d24a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d24a2",
  null
  
)

export default component.exports